export enum FilterType {
  Dropdown = 'dropdown',
  Radio = 'radio',
  Range = 'range',
  RadioRange = 'radioRange',
  Text = 'text',
  Set = 'set',
  Number = 'number',
  Date = 'date',
  DateRange = 'dateRange',
  RangeInput = 'rangeInput',
  ServiceFilter = 'serviceFilter',
  NSet = 'nset'
}

export enum FilterOption {
  Equals = 'equals',
  Contains = 'contains'
}

export interface FilterMap {
  colId: string;
  caseSensitive: boolean;
}

export interface FilterModel {
  colId: string;
  filter: any;
  filterType: string;
  type: string;
  caseSensitive: boolean;
}
